import { api } from '@/axios/instance/api';

export const apiExportOfferDetails = (params) => api.get(`offer-analytics/export`, params);
export const apiFetchCompanies = (params) => api.get(`offer-analytics/get_companies`, params);
export const apiFetchOffersVsRanges = (params) => api.get(`offer-analytics/get_offers_vs_ranges`, params);
export const fetchCompensation = (params) => api.get(`offer-analytics/get_compensation`, params);
export const fetchOverview = (params) => api.get(`offer-analytics/get_overview`, params);
export const sendFeedback = (params) => api.post(`emails/send-feedback`, params);
